<rt-dialog-header variant="default no-bottom-padding">
  <div layout-vertical>
    <div class="user-data-container" layout>
      <rt-avatar
        size="medium"
        [type]="!!avatarThumbUrl() ? 'image' : 'initials'"
        [imageSrc]="avatarThumbUrl()"
        [initials]="initials()"
        [context]="'admin'"
        margin-right-medium
      />
      <div layout layout-vertical>
        <div class="user-name">{{ fullName() }}</div>
        <span>{{ displayedEmail() }}</span>
      </div>
    </div>
    <rt-tabs [hasBottomSeparator]="false">
      <rt-tab
        (click)="setActiveTab(UserProfileTab.Profile)"
        [class.active]="activeComponent() === UserProfileTab.Profile"
        >{{ 'tlc.current_user.tabs.profile' | translate }}</rt-tab
      >
      @if (membersCount() && !isMobile) {
        <rt-tab
          (click)="setActiveTab(UserProfileTab.Companies)"
          [class.active]="activeComponent() === UserProfileTab.Companies"
          [count]="membersCount()"
          >{{ 'tlc.current_user.tabs.companies' | translate }}</rt-tab
        >
      }
      <rt-tab
        (click)="setActiveTab(UserProfileTab.Security)"
        [class.active]="activeComponent() === UserProfileTab.Security"
        >{{ 'tlc.current_user.tabs.security' | translate }}</rt-tab
      >
    </rt-tabs>
  </div>
</rt-dialog-header>
<rt-dialog-body variant="no-padding white">
  <ng-container *ngComponentOutlet="componentMap.get(activeComponent())" />
</rt-dialog-body>
